import CouponEditor from "../../components/coupon/couponEditor.comp";
import Layout from "../../components/layouts/layout.comp";
import { EditingMode } from "../../components/reuseables/form.comp";

export default function ProductCreatePage() {
  return (
    <Layout title={"Create Coupon"}>
      <CouponEditor editingMode={EditingMode.create} />
    </Layout>
  );
}
